import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import './App.css';

function EntityList({ title, entities }) {
  if (!entities || entities.length === 0) return null;
  
  return (
    <div className="entity-section">
      <h3>{title}</h3>
      <ul>
        {entities.map((entity, index) => (
          <li key={index}>
            {entity.name}
          </li>
        ))}
      </ul>
    </div>
  );
}

function App() {
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;

    setLoading(true);
    setError(null);
    
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setResults(response.data);
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while processing the file');
    } finally {
      setLoading(false);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ 
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'text/plain': ['.txt']
    }
  });

  return (
    <div className="App">
      <header className="App-header">
        <h1>Entity Extractor</h1>
      </header>
      
      <main>
        <div {...getRootProps()} className={`dropzone ${isDragActive ? 'active' : ''}`}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop the file here...</p>
          ) : (
            <p>Drag & drop a file here, or click to select</p>
          )}
        </div>

        {loading && <div className="loading">Processing file...</div>}
        
        {error && <div className="error">{error}</div>}
        
        {results && (
          <div className="results">
            <h2>Extracted Entities</h2>
            
            <EntityList title="People" entities={results.people} />
            <EntityList title="Companies" entities={results.companies} />
            <EntityList title="Products" entities={results.products} />
            <EntityList title="Countries" entities={results.countries} />
            <EntityList title="Vehicles" entities={results.vehicles} />
          </div>
        )}
      </main>
    </div>
  );
}

export default App;
